var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcLive = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 25C0 11.19 11.19 0 25 0C38.81 0 50 11.19 50 25C50 38.81 38.81 50 25 50C11.19 50 0 38.81 0 25ZM3.49 25C3.49 36.86 13.14 46.51 25 46.51C36.86 46.51 46.51 36.86 46.51 25C46.51 13.14 36.86 3.49 25 3.49C13.14 3.49 3.49 13.14 3.49 25ZM8.00806 19.656V31H10.2801H10.8721H15.7521V28.536H10.8721V19.656H8.00806ZM17.0862 19.656V31H19.9502V19.656H17.0862ZM25.4012 31L21.1292 19.656H24.1852L26.7341 26.9586L29.3212 19.656H32.3132L27.9932 31H25.4012ZM33.5081 19.656V31H35.7801H36.3721H41.9241V28.584H36.3721V26.392H41.3481V24.04H36.3721V22.072H41.8281V19.656H36.3721H35.7801H33.5081Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcLive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_live.2a46c296.svg";
export { ForwardRef as ReactComponent };